// extracted by mini-css-extract-plugin
export default {"modalOverlay":"OB-z","modalContent":"PB-z","header":"QB-z","close":"RB-z"};